//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VideoControls from '@/elements/editorial/video/video-controls.vue'
const RbEmbeddedVideo = () => import('@/elements/editorial/video/rb-embedded-video.vue')

import BannerLazyLoad from '@/scripts/libs/lazy-load/banner-lazy-load'
import { MOBILE } from '@/scripts/constants/media-query'
const BOTTOM_LEFT = 'bottom-left'
const TOP_LEFT = 'top-left'
const TOP_RIGHT = 'top-right'

export default {
  components: {
    RbEmbeddedVideo,
  },
  extends: VideoControls,
  props: {
    isDummyBanner: {
      type: Boolean,
      default: false,
    },
    isVCtaDirectiveEnabled: {
      type: Boolean,
      default: true,
    },
    fixedHeight: {
      type: Number,
      default: undefined,
    },
    size: {
      type: String,
      default: 'medium', // options: ['large', 'medium', 'small', 'xsmall', 'fixed']
    },
    isCopyExternal: {
      type: Boolean,
      default: false,
    },
    contentPosition: {
      type: String,
      default: 'center', // options: ['top-left', 'top-center' or 'top', 'top-right', 'left', 'center', 'right', 'bottom-left', 'bottom-center' or 'bottom', 'bottom-right']
    },
    isCtaOverlappingOnMobile: {
      type: Boolean,
      default: false,
    },

    /*
     * Image Props
     */
    imageDesktop: String,
    imageTablet: String,
    imageMobile: String,
    imageDesktopOnHover: String,
    imageAlt: String,
    imageFit: {
      type: String,
      default: 'cover',
    },
    isAnimationEnabled: {
      type: Boolean,
      default: false,
    },

    /*
     * Pill Props
     */
    pill: String,
    pillPosition: {
      type: String,
      default: 'top-left', // options: ['top-left', 'top-center', 'top-right', 'left', 'right', 'bottom-left', 'bottom-center' or 'bottom', 'bottom-right']
    },
    pillTheme: {
      type: String,
      default: 'dark', // options: ['dark', 'light', 'red']
    },
    pillMobilePosition: {
      type: String,
      default: 'top-center', // options: ['top-left', 'top-center' or 'top', 'top-right', 'left', 'right', 'bottom-left', 'bottom-center' or 'bottom', 'bottom-right']
    },
    pillIcon: {
      type: String,
      default: '',
    },
    pillIconOnTheRight: {
      type: Boolean,
      default: false,
    },
    pillCursor: {
      type: String,
      default: 'arrow',
    },
    /*
     * Text Module Props
     */
    theme: {
      type: String,
      default: 'dark', // options: ['dark', 'light']
    },
    textAlign: {
      type: String,
      default: 'center', // options: ['left', 'center', 'right']
    },
    isSearchAvailable: {
      type: Boolean,
      default: false,
    },
    isTextLayoutHorizontal: {
      /*
       * When this prop is active:
       * textAlign, isSearchAvailable, countdown, ctaMobileOrientation and verticalSpacing should be off
       * and also : contentPosition, isCtaOverlappingOnMobile should be off
       */
      type: Boolean,
      default: false,
    },
    countdownStart: Number,
    countdownEnd: Number,
    countdownHideIfExpired: {
      type: Boolean,
      default: false,
    },
    countdownFormat: {
      type: String,
      default: '%dd:%hh:%mm:%ss',
    },
    ctaMobileOrientation: {
      type: String,
      default: 'vertical', // options: ['vertical', 'horizontal']
    },
    verticalSpacing: {
      type: String,
      default: 'large', // options: ['large', 'small']
    },
    /*
     * Video Props
     * The base for this is in the VideoComponent which rbBanner is extending
     */
    videoSource: {
      type: String,
      default: '',
    },
    videoTranscript: {
      type: String,
      default: '',
    },
    mobileVideoSource: {
      type: String,
      default: '',
    },
    startVideoOnHover: {
      type: Boolean,
      default: false,
    },
    controlsPosition: {
      type: String,
      default: function () {
        if (
          (this.contentPosition === BOTTOM_LEFT && this.pill && this.pillPosition === TOP_LEFT) ||
          (this.contentPosition === TOP_LEFT && this.pill && this.pillPosition === BOTTOM_LEFT)
        ) {
          return TOP_RIGHT
        }

        if (
          this.contentPosition === BOTTOM_LEFT ||
          (this.pill && this.pillPosition === BOTTOM_LEFT)
        ) {
          return TOP_LEFT
        }

        return BOTTOM_LEFT
        // options: ['top-left', 'top-center' or 'top', 'top-right', 'left', 'center', 'right', 'bottom-left', 'bottom-center' or 'bottom', 'bottom-right']
      },
    },
    controlsMobilePosition: {
      type: String,
      default: function () {
        if (this.pill && this.pillMobilePosition === TOP_LEFT) {
          return TOP_RIGHT
        }
        return TOP_LEFT
        // options: ['top-left', 'top-center' or 'top', 'top-right', 'left', 'center', 'right', 'bottom-left', 'bottom-center' or 'bottom', 'bottom-right']
      },
    },
    isHigherPriority: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    isLazyLoadEnabled: {
      type: Boolean,
      default: true,
    },
    videoId: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    messageColor: {
      type: String,
      default: 'dark',
    },
    dynamicMargin: {
      type: String,
      default: 'x',
    },
    isWithNoImageBg: {
      type: Boolean,
      default: false,
    },
    inheritMessageColorFromTheme: {
      type: Boolean,
      default: false,
    },
    isSkeletonInLoadingImage: {
      type: Boolean,
      default: false,
    },
    headingTag: {
      type: String,
      default: 'h2',
    },
  },
  data() {
    return {
      isBannerLoaded: false,
      intersectionObserver: undefined,
      isMouseOnHover: false,
    }
  },
  computed: {
    getImageDesktop() {
      return this.isMouseOnHover && this.imageDesktopOnHover
        ? this.imageDesktopOnHover
        : this.imageDesktop
    },
    getDynamicStyle() {
      if (this.isSkeletonVisible) {
        return {
          opacity: 0,
          height: 0,
        }
      } else {
        return {
          height: this.fixedHeight ? `${this.fixedHeight}px` : '',
        }
      }
    },
    modifierClasses() {
      let isCtaOverlappingMobile = this.isCtaOverlappingOnMobile || this.size === 'large'
      return {
        ['rb-banner--' + this.size]: this.size,
        ['rb-banner--theme-' + this.theme]: this.theme,
        ['rb-banner--copy-horizontal-layout']: this.isTextLayoutHorizontal,
        ['rb-banner--external-content']: this.isCopyExternal,
        ['rb-banner--content-position-' + this.contentPosition]: this.contentPosition,
        ['rb-banner--cta-mobile-overlapping']: isCtaOverlappingMobile,
        ['rb-banner--hover-animation']: this.isBannerLoaded && this.isAnimationEnabled,
        ['rb-banner--ctas-available-' + this.ctasAvailable]: this.ctasAvailable,
        ['rb-banner--pill-available']: this.isPillAvailable,
        ['rb-banner--media-available']: this.isMediaAvailable,
        ['rb-banner--copy-available']: this.isCopyAvailable,
        ['rb-banner--image-available']: this.isImageAvailable,
        ['rb-banner--video-available']: this.isVideoAvailable,
        ['rb-banner--control-available']: this.isControlAvailable,
        ['rb-banner--fixed-height']: !!this.fixedHeight,
        ['rb-banner--skeleton']: this.isSkeletonVisible,
        ['rb-banner--clickable']: this.isVCtaDirectiveEnabled,
      }
    },

    isMobile() {
      return [MOBILE].includes(this.$mq)
    },

    isPillAvailable() {
      return !!this.pill
    },

    isMediaAvailable() {
      return (
        this.isImageAvailable ||
        this.isVideoAvailable ||
        this.isPillAvailable ||
        this.isVideoEmbeddedAvailable
      )
    },

    isImageAvailable() {
      return !!this.imageDesktop || !!this.imageTablet || !!this.imageMobile
    },

    isCopyAvailable() {
      return (
        !!this.$slots.title ||
        !!this.$slots.title_block ||
        !!this.$slots.excerpt ||
        !!this.$slots.excerpt_block ||
        !!this.$slots.subtitle ||
        !!this.$slots.subtitle_block
      )
    },

    isVideoAvailable() {
      return !!this.videoSource
    },

    isVideoEmbeddedAvailable() {
      return !!this.type && !!this.videoId
    },

    isControlAvailable() {
      return !!this.controls
    },
    isTitleAvailable() {
      return this.$slots.title || this.$slots.title_block
    },
    isExcerptAvailable() {
      return this.$slots.excerpt || this.$slots.excerpt_block
    },
    ctasAvailable() {
      if (this.$slots.cta_block) return this.$slots.cta_block.filter((el) => el.tag).length
      let count = 0
      if (this.$slots.cta_1) count++
      if (this.$slots.cta_2) count++
      return count
    },

    copyProps() {
      return {
        theme: this.theme,
        textAlign: this.textAlign,
        isSearchAvailable: this.isSearchAvailable,
        isLayoutHorizontal: this.isTextLayoutHorizontal,
        countdownStart: this.countdownStart,
        countdownEnd: this.countdownEnd,
        countdownHideIfExpired: this.countdownHideIfExpired,
        countdownFormat: this.countdownFormat,
        ctaMobileOrientation: this.ctaMobileOrientation,
        verticalSpacing:
          this.isCopyExternal || this.size === 'fixed' ? 'small' : this.verticalSpacing,
      }
    },

    pillModifierClasses() {
      return {
        ['rb-banner__pill-container--position-' + this.pillPosition]: this.pillPosition,
        ['rb-banner__pill-container--mobile-position-' + this.pillMobilePosition]:
          this.pillMobilePosition,
        ['rb-banner__pill-container--countdown']: this.countdownStart,
      }
    },

    videoControlsModifierClasses() {
      return {
        ['rb-banner__video-controls--position-' + this.controlsPosition]: this.controlsPosition,
        ['rb-banner__video-controls--mobile-position-' + this.controlsMobilePosition]:
          this.controlsMobilePosition,
        [this.countdownStart ? 'rb-banner__video-controls--mobile-position-' + 'countdown' : '']:
          this.controlsMobilePosition,
      }
    },

    pillColorClass() {
      switch (this.pillTheme) {
        case 'dark':
          return 'black'
        case 'red':
          return 'red'
        default:
          return 'white'
      }
    },
    getVideoCover() {
      return this.isMobile ? this.coverMobile : this.cover
    },
    getFetchPriority() {
      return this.isHigherPriority ? 'high' : 'auto'
    },
    getVideoKey() {
      return this.mobileVideoSource && this.isMobile
        ? 'rb-banner-video-mobile'
        : 'rb-banner-video-desktop'
    },
    isPillIconOnTheLeft() {
      return this.pillIcon && !this.pillIconOnTheRight
    },
    isPillIconOnTheRight() {
      return this.pillIcon && this.pillIconOnTheRight
    },
    getPillIconClass() {
      return `common__icon--${this.pillIcon}`
    },
    isSkeletonVisible() {
      return (
        this.isDummyBanner ||
        (!this.isBannerLoaded && this.isLazyLoadEnabled && !this.type && !this.videoId)
      )
    },
    isPlayVideoOnHoverEnabled() {
      return (
        !this.isMobile && (this.videoSource || this.mobileVideoSource) && this.startVideoOnHover
      )
    },
    textModuleMessageColor() {
      if (this.inheritMessageColorFromTheme) {
        return 'inherit'
      }
      if (this.isMediaAvailable) {
        return 'light'
      }
      if (this.isMobile) {
        return 'dark'
      }
      return this.messageColor
    },
  },
  watch: {
    getImageDesktop() {
      if (!this.isDummyBanner) {
        const image = this.$el.querySelector('img')
        BannerLazyLoad.resetObserver(image)
        BannerLazyLoad.observeImage(
          this.$el,
          this.removeSkeletonFromBanner,
          this.removeBannerOnError
        )
      }
    },
  },
  mounted() {
    if (!this.isDummyBanner) {
      if (this.isLazyLoadEnabled && this.isMediaAvailable) {
        BannerLazyLoad.observeImage(
          this.$el,
          this.removeSkeletonFromBanner,
          this.removeBannerOnError
        )
      } else {
        this.isBannerLoaded = true

        if (!this.$refs.video) {
          return
        }
        this.$refs.video.isMuted = this.muted
      }
    } else {
      this.isBannerLoaded = false
    }
  },
  beforeDestroy() {
    if (this.isLazyLoadEnabled && !this.isDummyBanner) {
      BannerLazyLoad.unobserveImage(this.$el)
    }
  },
  methods: {
    removeSkeletonFromBanner() {
      this.isBannerLoaded = true

      if (!this.$refs.video) {
        return
      }
      this.$refs.video.isMuted = this.muted

      if (this.autoplay) {
        this.play()
      }
    },
    removeBannerOnError() {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    onMouseEnter() {
      this.isMouseOnHover = true
      if (this.isPlayVideoOnHoverEnabled && !this.playing) {
        this.play()
      }
    },
    onMouseLeave() {
      this.isMouseOnHover = false
      if (this.isPlayVideoOnHoverEnabled && this.playing) {
        this.pause()
      }
    },
  },
}
